import type { NivelDeAplicacao } from '../../types/nivelDeAplicacao';

/** Como a tela fala de cada nível no plural ("2 cargos") e apontando ("este cargo"). */
export const PLURAL_DO_NIVEL: Record<NivelDeAplicacao, string> = {
  company: 'empresas',
  unit: 'unidades',
  department: 'setores',
  occupation: 'cargos',
  employee: 'funcionários',
};

export const SINGULAR_DO_NIVEL: Record<NivelDeAplicacao, string> = {
  company: 'empresa',
  unit: 'unidade',
  department: 'setor',
  occupation: 'cargo',
  employee: 'funcionário',
};

export const ESTE_NIVEL: Record<NivelDeAplicacao, string> = {
  company: 'esta empresa',
  unit: 'esta unidade',
  department: 'este setor',
  occupation: 'este cargo',
  employee: 'este funcionário',
};

/** De onde vem o que vale por herança: "já vale por vir do setor". */
export const DO_NIVEL: Record<NivelDeAplicacao, string> = {
  company: 'da empresa',
  unit: 'da unidade',
  department: 'do setor',
  occupation: 'do cargo',
  employee: 'do funcionário',
};

const FEMININO_IRREGULAR: Record<string, string> = { Nenhum: 'Nenhuma', Os: 'As', os: 'as', um: 'uma' };

/**
 * A palavra que concorda com o item: "aplicado" vira "aplicada" para fontes. Escreva no
 * masculino; com `feminino`, artigo e terminação em -o/-os viram -a/-as.
 */
export function flexionar(feminino: boolean | undefined, palavra: string): string {
  if (!feminino) return palavra;
  return FEMININO_IRREGULAR[palavra] ?? palavra.replace(/o(s?)$/, 'a$1');
}

export function contar(quantidade: number, singular: string, plural: string): string {
  return `${quantidade} ${quantidade === 1 ? singular : plural}`;
}

/** Chave de um destino em mapas: o id convertido, porque chega como string do banco. */
export function chaveDoDestino(destino: { nivel: NivelDeAplicacao; id: number | string }): string {
  return `${destino.nivel}:${Number(destino.id)}`;
}

export function mesmoId(a: number | string, b: number | string): boolean {
  return Number(a) === Number(b);
}

/** Para quem vale o que está aplicado no nível: "quem trabalha neste cargo". */
export const QUEM_DO_NIVEL: Record<NivelDeAplicacao, string> = {
  company: 'quem trabalha nesta empresa',
  unit: 'quem trabalha nos setores desta unidade',
  department: 'quem trabalha neste setor',
  occupation: 'quem trabalha neste cargo',
  employee: 'este funcionário',
};

/**
 * Na confirmação de remover, o que volta a valer quando o item também vem de cima: "Ruído também
 * vem do setor Produção: Soldador volta a seguir o de lá (Médio)."
 */
export function linhaDeVoltaASeguir(
  nomeDoItem: string,
  destino: { nome: string },
  origem: { nivel: NivelDeAplicacao; nome: string },
  valorDeCima?: string
): string {
  const valor = valorDeCima ? ` (${valorDeCima})` : '';
  return `${nomeDoItem} também vem ${DO_NIVEL[origem.nivel]} ${origem.nome}: ${destino.nome} volta a seguir o de lá${valor}.`;
}

/** Lista de nomes em português: "A", "A e B", "A, B e C". */
export function juntarNomes(nomes: string[]): string {
  if (nomes.length <= 1) return nomes.join('');
  return `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`;
}
